import {soapPost} from '@/api/ajaxSoap'
import {bizTypeMap} from '@/api/bizTypeMapping'
import {i18n} from '@/api/i18n'
import {$notify} from '@/global'
import { restUrls } from '@/api/rest/url'
import axios from 'axios'
import { userInfo } from '../../../global'
import Cookies from 'js-cookie'
import { MasterPropertyType } from '@/api/biz/bizEnum'

/* *****checkService*****/
//根据容器号获取容器号里的全部订单
export const getOrdersByContainerNo = async (parameters) => {
    let ret = null
    await soapPost(bizTypeMap.wms_check_customer_100,
        parameters)
        .done(function (data) {
            ret = data;
        })
    return ret
}

export const asyncLabel = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.getLabelInfo,
      parameters)
      .done(function (data) {
          ret = data;
      })
  return ret
}

export const getPlatformInfo = async (parameters) => {
    let ret = null
    await soapPost(bizTypeMap.wms_check_master_004,
        parameters)
        .done(function (data) {
            ret = data;
        })
    return ret
}

export const getHotSales = async (parameters) => {
    let ret = null
    await soapPost(bizTypeMap.getHotSales,
        parameters)
        .done(function (data) {
            ret = data;
        })
    return ret
}

export const occupyPlatformNo = async (parameters) => {
    let ret = null
    await soapPost(bizTypeMap.wms_check_master_006,
        parameters)
        .done(function (data) {
            ret = data;
        })
    return ret
}

export const changePlatformNo = async (parameters) => {
    let ret = null
    await soapPost(bizTypeMap.wms_check_master_005,
        parameters)
        .done(function (data) {
            ret = data;
        })
    return ret
}

export const activatePlatForm = async (parameters) => {
    let ret = null
    await soapPost(bizTypeMap.wms_check_customer_214,
        parameters, {noParseJson: true})
        .done(function (data) {
            ret = data;
        })
    return ret
}

export const bindOrderAndRebinNo = async (parameters) => {
    let ret = null
    await soapPost(bizTypeMap.wms_check_common_019,
        parameters, {noParseJson: true})
        .done(function (data) {
            ret = data;
        })
    return ret
}

export const getDicDetailByCatalog = async (parameters) => {
    let ret = null
    let callback = function (result) {
        if (result.resultCode === '1') {
            return JSON.parse(result.resultValue);
        } else if (result.resultCode === '2') {
            return null;
        } else {
            let message = i18n.t(result.resultCode)
            let config = {
                ternimal: false
            }
            $notify.error(message, config)
            return null;
        }
    }
    await soapPost(bizTypeMap.wms_check_master_008,
        parameters, {callback: callback})
        .done(function (data) {
            ret = data;
        })
    return ret
}

export const bindOrderAndCaseNo = async (parameters) => {
    let ret = null
    await soapPost(bizTypeMap.wms_check_customer_203,
parameters, {noParseJson: true})
        .done(function (data) {
            ret = data;
        })
    return ret
}

export const scanGoodsInfoByCodeFour = async (parameters) => {
    let ret = null
    let callback = function (result) {
        if (result.resultCode === '1') {
            return JSON.parse(result.resultValue);
        } else if (result.resultCode === '2') {
            return null;
        } else {
            let message = i18n.t(result.resultCode)
            let config = {
                ternimal: false
            }
            $notify.error(message, config)
            return null;
        }
    }
    await soapPost(bizTypeMap.wms_check_master_007,
        parameters, {callback: callback})
        .done(function (data) {
            ret = data;
        })
    return ret
}
export const specialRulesFilter = async (code) => {
  let result = null
  await soapPost(bizTypeMap.wms_specialRules_filter,{
    code,
    needExtAttr: 1,
    colNames: MasterPropertyType.getAllProperty
  })
  .done(function (data) {
    result = data;
  })
  return result
}

export const getGoodsInfoBySerialNo = async (parameters) => {
    let ret = null
    // await soapPost(bizTypeMap.wms_check_master_003, parameters)
    await soapPost(bizTypeMap.querySerialGoodsBySerial, parameters)
        .done(function (data) {
            ret = data;
        })
    return ret
}

export const validateSerialNoUsed = async (parameters) => {
    let ret = null
    let callback = function (result) {
        if (result.resultCode === '1') {
            return 1;
        } else {
            let message = i18n.t(result.resultCode)
            let config = {
                ternimal: false
            }
            $notify.error(message, config)
            return result.resultCode;
        }
    }
    await soapPost(bizTypeMap.wms_check_master_012,
        parameters, {callback: callback})
        .done(function (data) {
            ret = data;
        })
    return ret
}

export const releaseContainerBind = async (parameters) => {
    let ret = null
    await soapPost(bizTypeMap.wms_check_common_006,
        parameters)
        .done(function (data) {
            ret = data;
        })
    return ret
}

export const addCheckResultForCustomerOrder = async (parameters) => {
    let ret = null
    let callback = function (result) {
        let message = i18n.t(result.resultCode)
        if (result.resultCode === '1') {
            message = i18n.t("orderCheckFinish", [result.resultValue])
            $notify.success(message)
            return
        }
        let config = {
            ternimal: false
        }
        $notify.error(message, config)
    }
    await soapPost(bizTypeMap.wms_check_customer_200,
        parameters, {callback: callback})
        .done(function (data) {
            ret = data;
        })
    return ret
}

export const getListCheckRByOutboundNo = async (parameters) => {
    let ret = null
    await soapPost(bizTypeMap.wms_check_customer_104,
        parameters)
        .done(function (data) {
            ret = data;
        })
    return ret
}

export const unBindOrderAndCaseNo = async (parameters) => {
    let ret = null
    await soapPost(bizTypeMap.wms_check_customer_204,
        parameters, {noParseJson: true})
        .done(function (data) {
            ret = data;
        })
    return ret
}

export const occupyContainerNo = async (parameters) => {
    let ret = null
    await soapPost(bizTypeMap.wms_check_master_018,
        parameters, {noParseJson: true})
        .done(function (data) {
            ret = data;
        })
    return ret
}


export const backCloseContainer = async (parameters) => {
    let ret = null
    await soapPost(bizTypeMap.wms_check_customer_201,
        parameters, {noParseJson: true})
        .done(function (data) {
            ret = data;
        })
    return ret
}

export const backCloseContainerForHKM = async (parameters) => {
    let ret = null
    await soapPost(bizTypeMap.wms_check_customer_2011,
        parameters, {noParseJson: true})
        .done(function (data) {
            ret = data;
        })
    return ret
}

//订单创建
export const addOrder = async (parameters) => {
    let ret = null
    let callback = function (result) {
        console.log(JSON.stringify(result));
        let message = i18n.t(result.resultCode)
        let config = {
            ternimal: false
        }
        if (result.resultCode === '1' && parameters.orderId == result.resultValue) {
            message = result.resultValue
            $notify.info(message + "下单成功", config)
        } else {
            message = result.resultValue
            $notify.error(message, config)
        }



    }
    console.log(JSON.stringify(bizTypeMap.orderCreation));
    await soapPost(bizTypeMap.orderCreation,
        parameters, {callback: callback})
        .done(function (data) {
            ret = data;
        })
    return ret
}
/**
 *根据批次号查询订单号等，
 * @parm
 *@return
 */
export const queryParcelByBatchNo = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.wms_parcelHandover_queryParcelByBatchNo,
    parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}
export const deleteParcelByShipNo = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.wms_parcelHandover_deleteParcelByShipNo,
    parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}
export const insertParcelBatchNo = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.wms_parcelHandover_insertParcelBatchNo,
    parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}
export const queryPackageCountByBatchNo = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.wms_parcelHandover_queryPackageCountByBatchNo,
    parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}

export const insertParcelOneBatchNo = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.wms_parcelHandover_insertParcelOneBatchNo, parameters , { noShowError: true })
    .done(function (data) {
      ret = data;
    })
  return ret
}

export const batchInsertParcelOneBatchNo = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.wms_parcelHandover_batchInsertParcelOneBatchNo, parameters ,)
    .done(function (data) {
      ret = data;
    })
  return ret
}
/**
 *根据运单号查询订单、包裹号
 * @parm
 *@return
 */
export const queryParcelAndOutboundByShipNo = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.wms_parcelHandover_queryParcelAndOutboundByShipNo,
    parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}
export const queryParcelByShippingContainerNo = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.queryParcelByShippingContainerNo,
    parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}

export const insertParcelByShippingContainerNo = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.insertParcelByShippingContainerNo,
    parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}

export const addDeliveryOperationDetail = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.addDeliveryOperationDetail,
    parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}

export const pageDeliveryBacklog = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.pageDeliveryBacklog,
    parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}

export const unloadingQueryFile = async (data) => {
  let ret = null
  await soapPost(bizTypeMap.unloadingQueryFile,
    data)
    .done(function (data) {
      ret = data;
    })
  return ret
}

export const pageQueryDeliveryTaskM = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.pageQueryDeliveryTaskM,
    parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}
export const pageDeliveryOperationDetail = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.pageDeliveryOperationDetail,
    parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}
export const pageQueryDeliveryTaskMDetail = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.pageQueryDeliveryTaskMDetail,
    parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}
/**
 *根据运单号查询订单、包裹号
 * @parm
 *@return
 */
export const updateHandoverStatusBySuccess = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.wms_parcelHandover_updateHandoverStatusBySuccess,
    parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}

/**
 * 是否需要采集干线服务商标识
 * @parm
 * @return
 */
export const getGXServiceProviderMark = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.wms_parcelHandover_getGXServiceProviderMark,
    parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}

/**
 * 检查批次号是否合规
 * @parm
 * @return
 */
export const checkHandoverBatchNo = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.wms_parcelHandover_checkHandoverBatchNo,
    parameters, {translate: true})
    .done(function (data) {
      ret = data;
    })
  return ret
}

/**
 *批量交接 - 列表查询
 * @parm
 *@return
 */
export const queryBatchHandoverInfo = async (parameters) => {
    let ret = null
    await soapPost(bizTypeMap.wms_parcelBatchHandover_queryBatchHandoverInfo,
        parameters)
        .done(function (data) {
            ret = data;
        })
    return ret
}
/**
 *批量交接
 * @parm
 *@return
 */
export const batchHandoverHandle = async (parameters) => {
    let ret = null
    await soapPost(bizTypeMap.wms_parcelBatchHandover_batchHandoverHandle,
        parameters, { withoutWarehouse: true })
        .done(function (data) {
            ret = data;
        })
    return ret
}
/**
 *批量将按托订单转按箱
 * @parm
 *@return
 */
export const batchUpdateExpectPackagingMode = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.wms_parcelBatchHandover_batchUpdateExpectPackagingMode,
    parameters, { withoutWarehouse: true })
    .done(function (data) {
      ret = data;
    })
  return ret
}

/**
 *批量交接 - 获取批次号明细
 * @parm
 *@return
 */
export const printHandoverSheet = async (parameters) => {
    let ret = null
    await soapPost(bizTypeMap.wms_parcelBatchHandover_printHandoverSheet,
        parameters)
        .done(function (data) {
            ret = data;
        })
    return ret
}

/**
 * 单据打印 - 小鹏汽车打印明细
 * @parm
 *@return
 */
 export const printPalletHandoverSheet = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.printPalletHandoverSheet,
      parameters)
      .done(function (data) {
          ret = data;
      })
  return ret
}


/**
 *批量交接 - 查询普通包裹manifest
 * @parm
 *@return
 */
export const queryNormalPackage = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.wms_parcelBatchHandover_queryNormalPackage,
    parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}

/**
 *交接 - 更新manifest打印结果
 * @parm
 *@return
 */
export const updateManifestPrintResult = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.wms_parcelBatchHandover_updateManifestPrintResult,
    parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}
/**
 *批量交接 - 查询危险品包裹manifest
 * @parm
 *@return
 */
export const queryDangerousPackageByBatchNo = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.wms_parcelBatchHandover_queryDangerousPackage,
    parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}
/**
 *称重量方 - 获取默认单位
 * @parm
 *@return
 */
export const getWeighingSquareConfigUnit = async (parameters) => {
    let ret = null
    await soapPost(bizTypeMap.wms_parcelWeighingSquare_getWeighingSquareConfigUnit,
        parameters)
        .done(function (data) {
            ret = data;
        })
    return ret
}
/**
 *称重量方 - 提交数据
 * @parm
 *@return
 */
export const weighingSquareHandle = async (parameters) => {
    let ret = null
    await soapPost(bizTypeMap.wms_parcelWeighingSquare_weighingSquareHandle,
        parameters, { noParseJson: true })
        .done(function (data) {
            ret = data;
        })
    return ret
}
/**
/**
 *获取当前的格口号及对应的相关信息
 * @parm
 *@return
 */
 export const getSlotAndReletedInfo = async (parameters) => {
    let ret = null
    await soapPost(bizTypeMap.getSlotAndReletedInfo,
        parameters)
        .done(function (data) {
        ret = data;
        })
    return ret
}
/**
 *获取所有格口信息
 * @parm
 *@return
 */
 export const getAllSlotInfo = async (parameters) => {
    let ret = null
    await soapPost(bizTypeMap.getAllSlotInfo,
        parameters)
        .done(function (data) {
        ret = data;
        })
    return ret
}
/**
 *判断格口是否全部释放
 * @parm
 *@return
 */
export const isAllSlotsRelease = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.isAllSlotsRelease,
    parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}
/**
 *HKM门店分拨扫描包裹号
 * @parm
 *@return
 */
 export const scanPackageNo = async (parameters) => {
    let ret = null
    await soapPost(bizTypeMap.scanPackageNo,
        parameters)
        .done(function (data) {
        ret = data;
        })
    return ret
}
/**
 *HKM门店分拨扫描格口号
 * @parm
 *@return
 */
 export const scanSlotNo = async (parameters) => {
    let ret = null
    await soapPost(bizTypeMap.scanSlotNo,
        parameters)
        .done(function (data) {
        ret = data;
        })
    return ret
}
/**
 *HKM清空格口
 * @parm
 *@return
 */
 export const cleanSlot = async (parameters) => {
    let ret = null
    await soapPost(bizTypeMap.cleanSlot,
        parameters)
        .done(function (data) {
        ret = data;
        })
    return ret
}
/**
 *HKM获取格口明细
 * @parm
 *@return
 */
 export const getStoreDetail = async (parameters) => {
    let ret = null
    await soapPost(bizTypeMap.getStoreDetail,
        parameters)
        .done(function (data) {
        ret = data;
        })
    return ret
}
/**
 *删除已扫描包裹
 * @parm
 *@return
 */
 export const deleteScanedPackage = async (parameters) => {
    let ret = null
    await soapPost(bizTypeMap.deleteScanedPackage,
        parameters)
        .done(function (data) {
        ret = data;
        })
    return ret
}
/**
 * 校验本格口本波次订单是否都已经打包完成
 * @parm
 *@return
 */
 export const checkAllOrderHasBeenPackaged = async (parameters) => {
    let ret = null
    await soapPost(bizTypeMap.checkAllOrderHasBeenPackaged,
        parameters)
        .done(function (data) {
        ret = data;
        })
    return ret
}
/**
 * 强制完成格口
 * @parm
 *@return
 */
 export const forceCompleteSlot = async (parameters) => {
    let ret = null
    await soapPost(bizTypeMap.forceCompleteSlot,
        parameters)
        .done(function (data) {
        ret = data;
        })
    return ret
}

/**
 * HKM查询格口下未合流订单明细
 * @parm
 *@return
 */
export const findNotConfluenceDetail = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.findNotConfluenceDetail,
    parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}

/**
 *获取 当前仓的自绘面单配置
 * @parm
 *@return
 */
export const queryFaceSheet = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.wms_queryFaceSheet,
    parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}

// 待手工定位
export const queryShipmentMByManualLocate = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.wms_queryShipmentMByManualLocate, parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}
// 新待手工定位
export const queryShipmentMByManualLocateByPage = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.queryShipmentMByManualLocateByPage, parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}

// 查询可全选的订单总数
export const querySelectAllOrderLen = async params => {
  let ret = null
  await soapPost(bizTypeMap.querySelectAllOrderLen, params)
    .done(function (data) {
      ret = data
    })
  return ret
}
// 查询提总爆品的可选商品编码列表
export const queryExplosiveSkuCodeList = async params => {
  let ret = null
  await soapPost(bizTypeMap.queryExplosiveSkuCodeList, params)
    .done(function (data) {
      ret = data
    })
  return ret
}

// 查询订单下明细
export const queryManualLocateShipmentDByOutboundNo = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.wms_queryManualLocateShipmentDByOutboundNo, parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}

// 查询可定位储位库存信息
export const queryManualLocateStockInfo = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.wms_queryManualLocateStockInfo, parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}

// 查询已定位明细
export const queryManualLocateDetailByOrderAndSku = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.wms_queryManualLocateDetailByOrderAndSku, parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}

//  转自动定位
export const resetManualFlag = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.wms_resetManualFlag, parameters, {noParseJson: true})
    .done(function (data) {
      ret = data;
    })
  return ret
}

// 整单确认
export const manualLocateOrderConfirm = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.wms_manualLocateOrderConfirm, parameters, {noParseJson: true})
    .done(function (data) {
      ret = data;
    })
  return ret
}

// 整单确认前缺量校验
export const manualLocateOrderConfirmCheck = async (parameters) => {
  let ret = null
  const callback = function (result) {
    if (result.resultCode === '1900012') {
      // 需二次弹窗并再次请求
      return true
    } else if (result.resultCode === '1') {
      // 执行完成 无须再次请求
      return false
    } else {
      // 异常提示
      return result
    }
  }
  await soapPost(bizTypeMap.wms_manualLocateOrderConfirm, parameters, {noParseJson: true, callback})
    .done(function (data) {
      ret = data;
    })
  return ret
}

// 释放预占
export const manualLocateOrderPreQtyDecrease = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.wms_manualLocateOrderPreQtyDecrease, parameters, {noParseJson: true})
    .done(function (data) {
      ret = data;
    })
  return ret
}

// 执行定位 确认预占
export const saveLocateInfoAndStockLocation = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.wms_saveLocateInfoAndStockLocation, parameters, {noParseJson: true})
    .done(function (data) {
      ret = data;
    })
  return ret
}

// 分页查询可用库存
export const queryPagedManualLocateStockInfo = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.wms_queryPagedManualLocateStockInfo, parameters, {withoutWarehouse: true})
    .done(function (data) {
      ret = data;
    })
  return ret
}

// 分页查询可用库存
export const queryPagedManualLocateDetailByOrderAndSku = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.wms_queryPagedManualLocateDetailByOrderAndSku, parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}

// 查询订单商品明细分页
export const queryPageManualLocateShipmentDByOutboundNo = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.wms_queryPageManualLocateShipmentDByOutboundNo, parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}

export const setCookieTimer = async (parameters) => {
  await axios.get(restUrls.check_resource_url + '?resourceNo=' + '&intermediate=true' + '&_t_=' + new Date().getTime() + '&renewal=1', {
    timeout: 60000,
    headers: { 'X-Requested-With': 'XMLHttpRequest' }
  })
  const warehouseNo = Cookies.get('login.select.warehouse') || Cookies.get('warehouseNo')
  const userName = Cookies.get('userName')
  if (warehouseNo && userName) {
    localStorage.setItem(`lastRenewalTime_${warehouseNo}_${userName}`, Date.now())
  }
}

 /*货权转移-手动定位-开始*/
 //查询订单商品明细
  export const getOrderDetailList = async (parameters) => {
    let ret = null
    await soapPost(bizTypeMap.getOrderDetailList, parameters)
      .done(function (data) {
        ret = data;
      })
    return ret
  }
  //查询商品库存
  export const queryStockInfoForLocate = async (parameters) => {
    let ret = null
    await soapPost(bizTypeMap.queryStockInfoForLocate, parameters)
      .done(function (data) {
        ret = data;
      })
    return ret
  }
  //预占接口
  export const saveLockHandLocateResult = async (parameters) => {
    let ret = null
    await soapPost(bizTypeMap.saveLockHandLocateResult, parameters)
      .done(function (data) {
        ret = data;
      })
    return ret
  }
   //清空预占接口
   export const saveUnlockHandLocateResult = async (parameters) => {
    let ret = null
    await soapPost(bizTypeMap.saveUnlockHandLocateResult, parameters)
      .done(function (data) {
        ret = data;
      })
    return ret
  }
   //整单确认
   export const wholeOrderConfirm = async (parameters) => {
    let ret = null
    await soapPost(bizTypeMap.wholeOrderConfirm, parameters)
      .done(function (data) {
        ret = data;
      })
    return ret
  }
  // 整单确认前缺量校验
export const wholeOrderConfirmCheck = async (parameters) => {
  let ret = null
  const callback = function (result) {
    if (result.resultCode === '1900012') {
      // 需二次弹窗并再次请求
      return true
    } else if (result.resultCode === '1') {
      // 执行完成 无须再次请求
      return false
    } else {
      // 异常提示
      return result
    }
  }
  await soapPost(bizTypeMap.wholeOrderConfirm, parameters, {noParseJson: true, callback})
    .done(function (data) {
      ret = data;
    })
  return ret
}
  //查询商品定位明细
  export const getHandLocateResult = async (parameters) => {
    let ret = null
    await soapPost(bizTypeMap.getHandLocateResult, parameters)
      .done(function (data) {
        ret = data;
      })
    return ret
  }
 /*货权转移-手动定位-结束*/

 /**
 *批量交接 - 商品明细
 * @parm
 *@return
 */
export const queryPackageHandoverGoodsDetailByBatchNo = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.queryPackageHandoverGoodsDetailByBatchNo,
    parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}
 /**
 *批量交接 - 商品明细(EN)
 * @parm
 * @return
 */
 export const printPackageHandoverGoodsDetail = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.printPackageHandoverGoodsDetail,
    parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}
//提总定位
 export const batchLocateInfoAndStockLocation = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.batchLocateInfoAndStockLocation, parameters,{noParseJson:true})
    .done(function (data) {
      ret = data;
    })
  return ret
}
//提总辅助分析
export const batchLocateAssistedAnalysis = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.batchLocateAssistedAnalysis, parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}
//提总定位成功明细
export const queryBatchLocateSuccessInfos = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.queryBatchLocateSuccessInfos, parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}
//提总定位失败明细
export const queryBatchLocateFailedInfos = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.queryBatchLocateFailedInfos, parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}
//取消提总定位
export const batchLocateCancel = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.batchLocateCancel, parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}
//确认并生成拣货任务
export const batchLocateConfirmTaskAssign = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.batchLocateConfirmTaskAssign, parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}

// 搬仓-创建搬仓单
export const createMovePlanOrder = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.createMovePlanOrder, parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}
// 搬仓-查询库存信息
export const queryMovePlanStockInfo = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.queryMovePlanStockInfo, parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}

// 搬仓-查询有搬仓计划的所有货主信息
export const queryMovePlanOwners = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.queryMovePlanOwners, parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}

//  搬仓-根据订单号查询搬仓计划信息
export const queryMovePlanByOutboundNo = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.queryMovePlanByOutboundNo, parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}

// 取消搬仓
export const cancelMoveOrder = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.wmsCancelMoveOrder, parameters, {noParseJson: true})
    .done(function (data) {
      ret = data;
    })
  return ret
}

// 搬仓导入
export const importMovePlanStocks = async (parameters) => {
  const result = await axios.post(restUrls.importMovePlanStocks_url, parameters, {
    timeout: 60000,
    headers: { 'Content-Type': 'multipart/form-data;charset=UTF-8', 'authorization': Cookies.get('lwms.sec.token') }
  })
  return result
}

// 搬仓-根据仓号查询搬仓计划和货主信息的接口
export const queryMovePlanOwnerByWarehouseNo = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.queryMovePlanOwnerByWarehouseNo, parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}

// 校验序列号的包装批次是否为订单指定的包装批次
export const checkSerialLotNo = async (parameters) => {
  let ret = null
  await soapPost(bizTypeMap.checkSerialLotNo, parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}

// 绑定rebin墙
export const bindRebinWallNo = async (parameters) => {
  let ret = null
  Object.assign(parameters,{
    orgNo: userInfo.orgNo,
    distributeNo: userInfo.distributeNo,
    warehouseNo: userInfo.warehouseNo,
    operateUser: userInfo.userCode,
    updateUser: userInfo.userCode,
    userName: userInfo.userName,
  })
  await soapPost(bizTypeMap.bindRebinWallApi, parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}
// rebin路由
export const routeRebinWall = async (parameters) => {
  let ret = null
  Object.assign(parameters,{
    orgNo: userInfo.orgNo,
    distributeNo: userInfo.distributeNo,
    warehouseNo: userInfo.warehouseNo,
    operateUser: userInfo.userCode,
    updateUser: userInfo.userCode,
    userName: userInfo.userName,
  })
  await soapPost(bizTypeMap.routeRebinWallApi, parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}

// rebin绑定容器号
export const scanRebinContainer = async (parameters) => {
  let ret = null
  Object.assign(parameters,{
    orgNo: userInfo.orgNo,
    distributeNo: userInfo.distributeNo,
    warehouseNo: userInfo.warehouseNo,
    operateUser: userInfo.userCode,
    updateUser: userInfo.userCode,
    userName: userInfo.userName,
  })
  await soapPost(bizTypeMap.scanRebinContainer, parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}


// 删除rebin墙
export const releaseRebinWall = async (parameters) => {
  let ret = null
  Object.assign(parameters,{
    orgNo: userInfo.orgNo,
    distributeNo: userInfo.distributeNo,
    warehouseNo: userInfo.warehouseNo,
    operateUser: userInfo.userCode,
    updateUser: userInfo.userCode,
    userName: userInfo.userName,
  })
  await soapPost(bizTypeMap.releaseRebinWallApi, parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}

// 记录rebin明细
export const recordRebinDetail = async (parameters) => {
  let ret = null
  Object.assign(parameters,{
    orgNo: userInfo.orgNo,
    distributeNo: userInfo.distributeNo,
    warehouseNo: userInfo.warehouseNo,
    operateUser: userInfo.userCode,
    updateUser: userInfo.userCode,
    userName: userInfo.userName,
  })
  await soapPost(bizTypeMap.recordRebinDetailApi, parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}

// 订单rebin完成
export const checkByOutbound = async (parameters) => {
  let ret = null
  Object.assign(parameters,{
    orgNo: userInfo.orgNo,
    distributeNo: userInfo.distributeNo,
    warehouseNo: userInfo.warehouseNo,
    operateUser: userInfo.userCode,
    updateUser: userInfo.userCode,
    userName: userInfo.userName,
  })
  await soapPost(bizTypeMap.checkByOutboundApi, parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}

// 订单rebin完成
export const diffCheckByOutboundNo = async (parameters) => {
  let ret = null
  Object.assign(parameters,{
    orgNo: userInfo.orgNo,
    distributeNo: userInfo.distributeNo,
    warehouseNo: userInfo.warehouseNo,
    operateUser: userInfo.userCode,
    updateUser: userInfo.userCode,
    userName: userInfo.userName,
    createUser: userInfo.userCode,
  })
  await soapPost(bizTypeMap.diffCheckByOutboundNoApi, parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}
// rebin关闭容器 closeBigWaveByWallApi
export const closeBigWaveByWall = async (parameters) => {
  let ret = null
  Object.assign(parameters,{
    orgNo: userInfo.orgNo,
    distributeNo: userInfo.distributeNo,
    warehouseNo: userInfo.warehouseNo,
    operateUser: userInfo.userCode,
    updateUser: userInfo.userCode,
    userName: userInfo.userName,
    createUser: userInfo.userCode,
  })
  await soapPost(bizTypeMap.closeBigWaveByWallApi, parameters)
    .done(function (data) {
      ret = data;
    })
  return ret
}
// 生成交接批次号
export const generateHandoverBatchNo = async (parameters) => {
  let ret
  await soapPost(bizTypeMap.wms_parcelHandover_generateHandoverBatchNo, parameters, {noParseJson: true})
    .done(function (data) {
      ret = data
    })
  return ret
}